"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@headlessui/react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
var _get2 = _interopRequireDefault(require("lodash/get"));
var _intersection2 = _interopRequireDefault(require("lodash/intersection"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _sortBy2 = _interopRequireDefault(require("lodash/sortBy"));
var _uniq2 = _interopRequireDefault(require("lodash/uniq"));
var _uniqBy2 = _interopRequireDefault(require("lodash/uniqBy"));
var _xor2 = _interopRequireDefault(require("lodash/xor"));
var _SelectList = _interopRequireDefault(require("react-widgets/lib/SelectList"));
var _cccisdClickButton = _interopRequireDefault(require("cccisd-click-button"));
var _enlarge = _interopRequireDefault(require("cccisd-icons/svg/enlarge7"));
var _shrink = _interopRequireDefault(require("cccisd-icons/svg/shrink7"));
var _checkmark = _interopRequireDefault(require("cccisd-icons/checkmark"));
var _admin = require("../../selectors/admin.js");
var _admin2 = require("../../reducers/admin.js");
var _FilterBlock = _interopRequireDefault(require("../FilterBlock"));
var _cccisdDetectClickLocation = _interopRequireDefault(require("cccisd-detect-click-location"));
var _style = _interopRequireDefault(require("./style.css"));
var _CycleCard = require("../../pages/Deploy/CycleList/CycleCard");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var AppDefs = window.cccisd.appDefs;
var Fortress = window.cccisd.fortress;
var Header = function Header(_ref) {
  var organizationList = _ref.organizationList,
    projectList = _ref.projectList,
    project = _ref.project,
    assignment = _ref.assignment,
    selectedDeploymentIds = _ref.selectedDeploymentIds,
    currentDeployment = _ref.currentDeployment,
    surveyHandles = _ref.surveyHandles,
    dispatch = _ref.dispatch,
    leftSection = _ref.leftSection,
    rightSection = _ref.rightSection,
    setExpandedAll = _ref.setExpandedAll,
    match = _ref.match,
    history = _ref.history,
    filter = _ref.filter,
    changeFilter = _ref.changeFilter,
    _ref$showQuestCount = _ref.showQuestCount,
    showQuestCount = _ref$showQuestCount === void 0 ? true : _ref$showQuestCount,
    isExported = _ref.isExported,
    customSwitchProject = _ref.customSwitchProject,
    labelForProject = _ref.labelForProject,
    labelForProjectPlural = _ref.labelForProjectPlural,
    _ref$limitProjectsByP = _ref.limitProjectsByPermissions,
    limitProjectsByPermissions = _ref$limitProjectsByP === void 0 ? [] : _ref$limitProjectsByP,
    _ref$projectIdWhiteli = _ref.projectIdWhitelist,
    projectIdWhitelist = _ref$projectIdWhiteli === void 0 ? null : _ref$projectIdWhiteli,
    _ref$showProjectDropd = _ref.showProjectDropdown,
    showProjectDropdown = _ref$showProjectDropd === void 0 ? false : _ref$showProjectDropd,
    _ref$allowAllQuests = _ref.allowAllQuests,
    allowAllQuests = _ref$allowAllQuests === void 0 ? false : _ref$allowAllQuests,
    _ref$assignmentIdWhit = _ref.assignmentIdWhitelist,
    assignmentIdWhitelist = _ref$assignmentIdWhit === void 0 ? null : _ref$assignmentIdWhit,
    customSwitchQuest = _ref.customSwitchQuest,
    _ref$labelForQuest = _ref.labelForQuest,
    labelForQuest = _ref$labelForQuest === void 0 ? 'Quest' : _ref$labelForQuest,
    _ref$showQuestDropdow = _ref.showQuestDropdown,
    showQuestDropdown = _ref$showQuestDropdow === void 0 ? false : _ref$showQuestDropdow,
    currentDeploymentId = _ref.currentDeploymentId,
    customSwitchDeployment = _ref.customSwitchDeployment,
    _ref$deploymentDropdo = _ref.deploymentDropdownNotMulti,
    deploymentDropdownNotMulti = _ref$deploymentDropdo === void 0 ? false : _ref$deploymentDropdo,
    _ref$deploymentDropdo2 = _ref.deploymentDropdownSingleType,
    deploymentDropdownSingleType = _ref$deploymentDropdo2 === void 0 ? false : _ref$deploymentDropdo2,
    _ref$labelForDeployme = _ref.labelForDeployment,
    labelForDeployment = _ref$labelForDeployme === void 0 ? 'Data Collection Wave' : _ref$labelForDeployme,
    _ref$showDeploymentDr = _ref.showDeploymentDropdown,
    showDeploymentDropdown = _ref$showDeploymentDr === void 0 ? false : _ref$showDeploymentDr,
    _ref$deploymentIdWhit = _ref.deploymentIdWhitelist,
    deploymentIdWhitelist = _ref$deploymentIdWhit === void 0 ? null : _ref$deploymentIdWhit,
    _ref$showRepeatableDe = _ref.showRepeatableDeploymentChildren,
    showRepeatableDeploymentChildren = _ref$showRepeatableDe === void 0 ? true : _ref$showRepeatableDe,
    _ref$allowAllSurveys = _ref.allowAllSurveys,
    allowAllSurveys = _ref$allowAllSurveys === void 0 ? true : _ref$allowAllSurveys,
    customSwitchSurvey = _ref.customSwitchSurvey,
    _ref$labelForSurvey = _ref.labelForSurvey,
    labelForSurvey = _ref$labelForSurvey === void 0 ? 'Survey' : _ref$labelForSurvey,
    _ref$showSurveyDropdo = _ref.showSurveyDropdown,
    showSurveyDropdown = _ref$showSurveyDropdo === void 0 ? false : _ref$showSurveyDropdo;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    deploymentDropdownVisible = _useState2[0],
    setDeploymentDropdownVisible = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    surveyDropdownVisible = _useState4[0],
    setSurveyDropdownVisible = _useState4[1];
  var _useState5 = (0, _react.useState)(''),
    _useState6 = _slicedToArray(_useState5, 2),
    deploymentSearchTerm = _useState6[0],
    setDeploymentSearchTerm = _useState6[1];
  var questCount = (0, _get2["default"])(project, 'flows.assignmentList.length', 0);
  var getProjectLabel = function getProjectLabel(plural) {
    var hasLabelProp = plural && labelForProjectPlural || !plural && labelForProject;
    if (hasLabelProp) {
      return plural ? labelForProjectPlural : labelForProject;
    }
    var questProjectSettings = AppDefs.pawn.groups.find(function (item) {
      return item.handle === 'questproject';
    });
    if (questProjectSettings) {
      return plural ? questProjectSettings.labelPlural : questProjectSettings.label;
    }
    return plural ? 'Quest Projects' : 'Quest Project';
  };
  function switchProject(_x) {
    return _switchProject.apply(this, arguments);
  }
  function _switchProject() {
    _switchProject = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(event) {
      var newProjectId;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              newProjectId = Number(event.target.value);
              if (!(newProjectId === project.projectId)) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return");
            case 3:
              if (!customSwitchProject) {
                _context.next = 7;
                break;
              }
              _context.next = 6;
              return customSwitchProject(newProjectId);
            case 6:
              return _context.abrupt("return");
            case 7:
              // replace :projectId and remove all other params
              history.push(match.path.replace(/:projectId\??/, newProjectId).replace(/\/?:[\w\d]+\??/gi, ''));
            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _switchProject.apply(this, arguments);
  }
  var assignments = (0, _reactRedux.useSelector)(function (state) {
    return (0, _admin.getCurrentProjectAssignments)(state.assignment.admin);
  });
  var activeAssignments = assignments.filter(function (item) {
    return !item.archived && (!Array.isArray(assignmentIdWhitelist) || assignmentIdWhitelist.map(function (i) {
      return Number.parseInt(i, 10);
    }).includes(Number.parseInt(item.assignmentId, 10)));
  });
  function switchAssignment(_x2) {
    return _switchAssignment.apply(this, arguments);
  }
  function _switchAssignment() {
    _switchAssignment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(event) {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!customSwitchQuest) {
                _context2.next = 4;
                break;
              }
              _context2.next = 3;
              return customSwitchQuest(event.target.value);
            case 3:
              return _context2.abrupt("return");
            case 4:
              _context2.next = 6;
              return dispatch((0, _admin2.setCurrentAssignmentId)(Number(event.target.value)));
            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return _switchAssignment.apply(this, arguments);
  }
  var deployments = (0, _reactRedux.useSelector)(function (state) {
    return (0, _admin.getCurrentAssignmentDeployments)(state.assignment.admin);
  });
  var activeDeployments = deployments.filter(function (item) {
    return !item.archived && (showRepeatableDeploymentChildren || !item.parentDeploymentId) && (!Array.isArray(deploymentIdWhitelist) || deploymentIdWhitelist.map(function (i) {
      return Number.parseInt(i, 10);
    }).includes(Number.parseInt(item.deploymentId, 10)));
  });
  var filteredActiveDeployments = deploymentSearchTerm === '' ? activeDeployments : activeDeployments.filter(function (deployment) {
    return deployment.label.toLowerCase().includes(deploymentSearchTerm.toLowerCase());
  });
  function switchSurveyHandleMulti(_x3) {
    return _switchSurveyHandleMulti.apply(this, arguments);
  }
  function _switchSurveyHandleMulti() {
    _switchSurveyHandleMulti = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(value) {
      var handles;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              handles = value.map(function (item) {
                return (0, _get2["default"])(item, 'surveyHandle', item);
              });
              dispatch((0, _admin2.setCurrentSurveyHandles)(handles));
            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return _switchSurveyHandleMulti.apply(this, arguments);
  }
  var selectedDeployments = activeDeployments.filter(function (item) {
    return selectedDeploymentIds.includes(item.deploymentId);
  });
  var selectedDeploymentType = selectedDeployments.length > 0 ? selectedDeployments[0].type : null;
  var deploymentClosedRoster = selectedDeployments.length > 0 ? selectedDeployments[0].settings.closedRoster : false;

  // there could be a deployment set in state, but if no deployment dropdown
  // we want the survey dropdown to reflect all surveys in the assignment
  var assignmentSurveys = (0, _reactRedux.useSelector)(function (state) {
    return (0, _admin.getCurrentAssignmentSurveys)(state.assignment.admin);
  });
  var activeSurveys = (0, _sortBy2["default"])((0, _uniqBy2["default"])(assignmentSurveys.filter(function (s) {
    return !s.archived;
  }), 'surveyHandle'), 'position');
  function setCheckedSurveysByDeployments(deploymentIds) {
    var _ref2, _ref3;
    var currentCheckedSurveyHandles = surveyHandles;
    var currentCheckedDeployments = deployments.filter(function (item) {
      return selectedDeploymentIds.includes(item.deploymentId);
    });
    var currentHandles = currentCheckedDeployments.map(function (item) {
      return (0, _get2["default"])(item, 'settings.options', []);
    });
    var currentUniqueSurveyHandles = (0, _uniq2["default"])((_ref2 = []).concat.apply(_ref2, _toConsumableArray(currentHandles)));
    var targetCheckedDeployments = deployments.filter(function (item) {
      return deploymentIds.includes(item.deploymentId);
    });
    var targetHandles = targetCheckedDeployments.map(function (item) {
      return (0, _get2["default"])(item, 'settings.options', []);
    });
    var targetUniqueSurveyHandles = (0, _uniq2["default"])((_ref3 = []).concat.apply(_ref3, _toConsumableArray(targetHandles)));
    if (currentCheckedSurveyHandles.length === 0 || (0, _isEmpty2["default"])((0, _xor2["default"])(currentCheckedSurveyHandles, currentUniqueSurveyHandles))) {
      switchSurveyHandleMulti((0, _intersection2["default"])(targetUniqueSurveyHandles, activeSurveys.map(function (s) {
        return s.surveyHandle;
      })));
    }
  }
  var assignmentDisplayName = labelForQuest !== null ? labelForQuest : (0, _get2["default"])(AppDefs, 'app.vocabulary.assignment', 'Quest');
  var deploymentDisplayName = labelForDeployment !== null ? labelForDeployment : (0, _get2["default"])(AppDefs, 'app.vocabulary.deployment', 'Data Collection Wave');
  var surveyDisplayName = labelForSurvey !== null ? labelForSurvey : (0, _get2["default"])(AppDefs, 'app.vocabulary.survey', 'Survey');
  var disabledDeploymentIds = !deploymentDropdownSingleType || selectedDeploymentType === null ? [] : activeDeployments.filter(function (item) {
    return item.type !== selectedDeploymentType || item.settings.closedRoster !== deploymentClosedRoster;
  }).map(function (item) {
    return item.deploymentId;
  });
  var currentDeploymentIds = selectedDeploymentIds.filter(function (item) {
    return !disabledDeploymentIds.includes(item);
  });
  function switchDeploymentMulti(value) {
    var deploymentIds = value.map(function (item) {
      return item.deploymentId;
    });
    var current = _toConsumableArray(deploymentIds);

    // If dropdown is restricted to a single type AND there is at least one
    // deployment selected, then there might be deployments to disable
    if (deploymentDropdownSingleType && value.length) {
      var selected = activeDeployments.filter(function (item) {
        return deploymentIds.includes(item.deploymentId);
      });
      if (selected.length) {
        var deploymentType = selected[0].type;
        var closedRoster = selected[0].settings.closedRoster;
        var disabled = activeDeployments.filter(function (item) {
          return item.type !== deploymentType || item.settings.closedRoster !== closedRoster;
        }).map(function (item) {
          return item.deploymentId;
        });
        current = deploymentIds.filter(function (item) {
          return !disabled.includes(item);
        });
      }
    }
    if (showSurveyDropdown) {
      setCheckedSurveysByDeployments(deploymentIds);
    }
    dispatch((0, _admin2.setSelectedDeploymentIds)(deploymentIds));
    dispatch((0, _admin2.setCurrentDeploymentIds)(current));
  }
  function switchDeploymentSingle(value) {
    dispatch((0, _admin2.setSelectedDeploymentIds)([Number(value)]));
    dispatch((0, _admin2.setCurrentDeploymentIds)([Number(value)]));
  }
  function getDeploymentButtonLabel() {
    if (activeDeployments.length === 0) {
      return "No ".concat(deploymentDisplayName, " to select");
    }
    if (currentDeploymentIds.length === 1) {
      var d = activeDeployments.find(function (item) {
        return item.deploymentId === currentDeploymentIds[0];
      });
      return d ? getDeploymentLabel(d) : '';
    }
    return "".concat(currentDeploymentIds.length, " selected");
  }
  function getSurveyButtonLabel() {
    if (surveyHandles.length === 1) {
      var s = activeSurveys.find(function (item) {
        return item.surveyHandle === surveyHandles[0];
      });
      return s ? s.label : '';
    }
    return "".concat(surveyHandles.length || 'All', " selected");
  }

  /* /////////////////////////////////////////////////////////////////////////
  // RENDER-RELATED /////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  function renderProjectDropdown() {
    if (!showProjectDropdown) {
      return null;
    }
    var narrowedProjectList = !Array.isArray(projectIdWhitelist) ? projectList : projectList.filter(function (p) {
      return projectIdWhitelist.map(function (i) {
        return Number.parseInt(i, 10);
      }).includes(Number.parseInt(p.groupId, 10));
    });
    narrowedProjectList = narrowedProjectList.filter(function (p) {
      return !isExported || project && p.groupId === project.groupId || Fortress.hasAnyAccess(limitProjectsByPermissions, p.groupId);
    });
    if (narrowedProjectList.length === 0) {
      return /*#__PURE__*/_react["default"].createElement("select", {
        className: "form-control",
        style: {
          width: 'auto',
          maxWidth: '200px'
        },
        disabled: true
      }, /*#__PURE__*/_react["default"].createElement("option", null, "There are no ", getProjectLabel(true)));
    }
    var usedOrganizations = narrowedProjectList.reduce(function (list, item) {
      list.add(item.organizationId);
      return list;
    }, new Set());
    var isOneOrganization = usedOrganizations.size === 1;
    var options;
    if (isOneOrganization) {
      options = narrowedProjectList.map(function (item) {
        return /*#__PURE__*/_react["default"].createElement("option", {
          key: item.groupId,
          value: item.groupId
        }, item.label);
      });
    } else {
      options = organizationList.filter(function (org) {
        return usedOrganizations.has(org.groupId);
      }).map(function (org) {
        return /*#__PURE__*/_react["default"].createElement("optgroup", {
          key: org.groupId,
          label: org.label
        }, narrowedProjectList.filter(function (pr) {
          return pr.organizationId === org.groupId;
        }).map(function (pr) {
          return /*#__PURE__*/_react["default"].createElement("option", {
            key: pr.groupId,
            value: pr.groupId
          }, pr.label);
        }));
      });
    }
    return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("label", {
      htmlFor: "cccisd-assignment-project-dropdown"
    }, getProjectLabel()), /*#__PURE__*/_react["default"].createElement("select", {
      id: "cccisd-assignment-project-dropdown",
      className: "form-control",
      style: {
        width: 'auto',
        maxWidth: '200px'
      },
      value: project && project.groupId || 0,
      onChange: switchProject
    }, options));
  }
  var renderExpandCollapseButtons = questCount > 0 && setExpandedAll ? /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: 'btn btn-default ' + _style["default"].button,
    id: "cccisd-expand-all-button",
    onClick: function onClick() {
      return dispatch(setExpandedAll(true));
    },
    title: "Expand All"
  }, /*#__PURE__*/_react["default"].createElement(_enlarge["default"], null)), ' ', /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: 'btn btn-default ' + _style["default"].button,
    id: "cccisd-collapse-all-button",
    onClick: function onClick() {
      return dispatch(setExpandedAll(false));
    },
    title: "Collapse All"
  }, /*#__PURE__*/_react["default"].createElement(_shrink["default"], null))) : null;
  var renderQuestDropdown = !showQuestDropdown ? null : /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: "cccisd-assignment-assignment-dropdown"
  }, assignmentDisplayName), /*#__PURE__*/_react["default"].createElement("select", {
    className: "form-control",
    disabled: !activeAssignments.length,
    id: "cccisd-assignment-assignment-dropdown",
    onChange: switchAssignment,
    style: {
      width: 'auto',
      maxWidth: '200px'
    },
    value: assignment ? assignment.assignmentId : 0
  }, allowAllQuests && /*#__PURE__*/_react["default"].createElement("option", {
    key: "all_assignments",
    value: "0"
  }, "All ", assignmentDisplayName, "s"), !!activeAssignments.length && activeAssignments.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement("option", {
      key: item.assignmentId,
      value: item.assignmentId
    }, item.label);
  }), !activeAssignments.length && /*#__PURE__*/_react["default"].createElement("option", {
    key: "empty",
    value: ""
  }, "No ", assignmentDisplayName, " to select")));
  function getDeploymentLabel(item) {
    var label = item === null || item === void 0 ? void 0 : item.label;
    if (!label) {
      if (item !== null && item !== void 0 && item.parentDeploymentId) {
        var parent = activeDeployments.find(function (d) {
          return d.deploymentId === Number(item.parentDeploymentId);
        });
        label = parent ? parent.label : '';
      }
      if (!label) {
        // some other type of programmatically created deployment
        label = "".concat(item === null || item === void 0 ? void 0 : item.assignment.label, " (").concat(item === null || item === void 0 ? void 0 : item.type, " ").concat(item === null || item === void 0 ? void 0 : item.hash, ")");
      }
    }
    if (item !== null && item !== void 0 && item.timepoint && !(item !== null && item !== void 0 && item.parentDeploymentId)) {
      label += ' - Timepoint ' + item.timepoint;
    }
    return label;
  }
  function renderDeploymentDropdown() {
    if (!showDeploymentDropdown) {
      return null;
    }
    if (deploymentDropdownNotMulti) {
      return activeDeployments.length === 0 ? /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("label", null, deploymentDisplayName), /*#__PURE__*/_react["default"].createElement("select", {
        className: "form-control",
        style: {
          width: 'auto',
          maxWidth: '200px'
        },
        disabled: true
      }, /*#__PURE__*/_react["default"].createElement("option", null, "No ", deploymentDisplayName, " to select"))) : /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_react2.Combobox, {
        as: "div",
        id: "cccisd-assignment-deployment-dropdown",
        value: currentDeploymentId,
        onChange: switchDeploymentSingle
      }, /*#__PURE__*/_react["default"].createElement(_react2.Combobox.Label, null, deploymentDisplayName), /*#__PURE__*/_react["default"].createElement("div", {
        className: "input-group"
      }, /*#__PURE__*/_react["default"].createElement(_react2.Combobox.Input, {
        className: "form-control",
        onFocus: function onFocus(event) {
          return event.target.select();
        },
        displayValue: function displayValue() {
          return getDeploymentLabel(currentDeployment);
        },
        onChange: function onChange(event) {
          return setDeploymentSearchTerm(event.target.value);
        }
      }), /*#__PURE__*/_react["default"].createElement("span", {
        className: "input-group-btn"
      }, /*#__PURE__*/_react["default"].createElement(_react2.Combobox.Button, {
        className: "btn btn-default",
        onClick: function onClick() {
          return setDeploymentSearchTerm('');
        }
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "caret"
      })))), /*#__PURE__*/_react["default"].createElement(_react2.Combobox.Options, {
        style: {
          position: 'absolute',
          backgroundColor: 'white',
          zIndex: 99999,
          marginTop: '1em',
          boxShadow: '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)',
          width: '100%',
          maxWidth: '60vw',
          maxHeight: '50vh',
          listStyleType: 'none',
          borderRadius: '1rem',
          border: '1px solid lightgray',
          padding: '0',
          overflowX: 'scroll'
        }
      }, filteredActiveDeployments.map(function (item, i) {
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
          key: item.deploymentId
        }, i !== 0 && /*#__PURE__*/_react["default"].createElement("hr", {
          style: {
            margin: '0'
          }
        }), /*#__PURE__*/_react["default"].createElement(_react2.Combobox.Option, {
          key: item.deploymentId,
          value: item.deploymentId,
          style: {
            cursor: 'pointer'
          }
        }, function (_ref4) {
          var selected = _ref4.selected,
            active = _ref4.active;
          return /*#__PURE__*/_react["default"].createElement("div", {
            style: {
              position: 'relative',
              paddingLeft: '4rem',
              backgroundColor: active && 'lightblue'
            }
          }, selected && /*#__PURE__*/_react["default"].createElement("div", {
            style: {
              position: 'absolute',
              left: '2rem',
              top: '1.75rem'
            }
          }, /*#__PURE__*/_react["default"].createElement(_checkmark["default"], null)), /*#__PURE__*/_react["default"].createElement(_CycleCard.CycleCardDetails, {
            cycle: item,
            deployments: activeDeployments
          }));
        }));
      }))));
    }
    var showAllNoneButtons = deploymentDropdownVisible && activeDeployments.length > 1;
    var allSelectableDeployments = activeDeployments.filter(function (a) {
      return !disabledDeploymentIds.includes(a.deploymentId);
    });
    return /*#__PURE__*/_react["default"].createElement(_cccisdDetectClickLocation["default"], {
      clickedOutside: function clickedOutside() {
        return setDeploymentDropdownVisible(false);
      }
    }, /*#__PURE__*/_react["default"].createElement("label", {
      htmlFor: "cccisd-assignment-deployment-dropdown"
    }, deploymentDisplayName), /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
      title: getDeploymentButtonLabel(),
      className: "btn btn-default",
      onClick: function onClick() {
        return setDeploymentDropdownVisible(!deploymentDropdownVisible);
      },
      style: {
        display: 'block',
        width: '100%',
        textAlign: 'left'
      }
    }), showAllNoneButtons && /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        position: 'absolute'
      }
    }, /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
      className: "btn btn-xs btn-default",
      isDisabled: allSelectableDeployments.length === selectedDeploymentIds.length,
      onClick: function onClick() {
        return switchDeploymentMulti(allSelectableDeployments);
      },
      title: "Select All"
    }), /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
      className: "btn btn-xs btn-default",
      isDisabled: selectedDeploymentIds.length === 0,
      onClick: function onClick() {
        return switchDeploymentMulti([]);
      },
      title: "Deselect All"
    })), /*#__PURE__*/_react["default"].createElement(_SelectList["default"], {
      multiple: true,
      data: activeDeployments,
      disabled: disabledDeploymentIds,
      textField: function textField(item) {
        return getDeploymentLabel(item);
      },
      valueField: "deploymentId",
      onChange: switchDeploymentMulti,
      value: selectedDeploymentIds,
      style: {
        display: deploymentDropdownVisible ? 'block' : 'none',
        height: 'auto',
        marginTop: showAllNoneButtons ? '2.5rem' : 0,
        position: 'absolute',
        zIndex: 10
      }
    }));
  }
  function renderSurveyDropdown() {
    if (!showSurveyDropdown) {
      return null;
    }
    var showAllNoneButtons = surveyDropdownVisible && activeSurveys.length > 1;
    var surveyDropdownData = activeSurveys.map(function (item) {
      return {
        surveyHandle: item.surveyHandle,
        surveyLabel: item.label
      };
    });
    return /*#__PURE__*/_react["default"].createElement(_cccisdDetectClickLocation["default"], {
      clickedOutside: function clickedOutside() {
        return setSurveyDropdownVisible(false);
      }
    }, /*#__PURE__*/_react["default"].createElement("label", {
      htmlFor: "cccisd-assignment-survey-dropdown"
    }, surveyDisplayName), /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
      title: getSurveyButtonLabel(),
      className: "btn btn-default",
      onClick: function onClick() {
        return setSurveyDropdownVisible(!surveyDropdownVisible);
      },
      style: {
        display: 'block',
        maxWidth: '400px',
        whiteSpace: 'normal'
      }
    }), showAllNoneButtons && /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        position: 'absolute'
      }
    }, /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
      className: "btn btn-xs btn-default",
      isDisabled: surveyDropdownData.length === surveyHandles.length,
      onClick: function onClick() {
        return switchSurveyHandleMulti(surveyDropdownData);
      },
      title: "Select All"
    }), /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
      className: "btn btn-xs btn-default",
      isDisabled: surveyHandles.length === 0,
      onClick: function onClick() {
        return switchSurveyHandleMulti([]);
      },
      title: "Deselect All"
    })), /*#__PURE__*/_react["default"].createElement(_SelectList["default"], {
      multiple: true,
      data: surveyDropdownData,
      textField: "surveyLabel",
      valueField: "surveyHandle",
      onChange: switchSurveyHandleMulti,
      value: surveyHandles,
      style: {
        display: surveyDropdownVisible ? 'block' : 'none',
        height: 'auto',
        marginTop: showAllNoneButtons ? '2.5rem' : 0,
        position: 'absolute',
        zIndex: 11
      }
    }));
  }
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].wrapper
  }, renderProjectDropdown(), showQuestCount && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].count
  }, "Quests (", questCount, ")"), renderExpandCollapseButtons, changeFilter && /*#__PURE__*/_react["default"].createElement(_FilterBlock["default"], {
    value: filter,
    onChange: function onChange(value) {
      return dispatch(changeFilter(value));
    }
  }), renderQuestDropdown, renderDeploymentDropdown(), renderSurveyDropdown(), leftSection && /*#__PURE__*/_react["default"].createElement("div", null, leftSection), rightSection && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].rightSection
  }, rightSection)));
};
Header.propTypes = {
  organizationList: _propTypes["default"].array,
  projectList: _propTypes["default"].array,
  project: _propTypes["default"].object,
  assignment: _propTypes["default"].object,
  selectedDeploymentIds: _propTypes["default"].array,
  currentDeployment: _propTypes["default"].object,
  surveyHandles: _propTypes["default"].array,
  dispatch: _propTypes["default"].func,
  leftSection: _propTypes["default"].node,
  rightSection: _propTypes["default"].node,
  setExpandedAll: _propTypes["default"].func,
  match: _propTypes["default"].object,
  history: _propTypes["default"].object,
  filter: _propTypes["default"].string,
  changeFilter: _propTypes["default"].func,
  showQuestCount: _propTypes["default"].bool,
  isExported: _propTypes["default"].bool,
  customSwitchProject: _propTypes["default"].func,
  labelForProject: _propTypes["default"].string,
  labelForProjectPlural: _propTypes["default"].string,
  limitProjectsByPermissions: _propTypes["default"].array,
  projectIdWhitelist: _propTypes["default"].array,
  showProjectDropdown: _propTypes["default"].bool,
  allowAllQuests: _propTypes["default"].bool,
  assignmentIdWhitelist: _propTypes["default"].array,
  customSwitchQuest: _propTypes["default"].func,
  labelForQuest: _propTypes["default"].string,
  showQuestDropdown: _propTypes["default"].bool,
  currentDeploymentId: _propTypes["default"].number,
  customSwitchDeployment: _propTypes["default"].func,
  deploymentDropdownNotMulti: _propTypes["default"].bool,
  deploymentDropdownSingleType: _propTypes["default"].bool,
  labelForDeployment: _propTypes["default"].string,
  showDeploymentDropdown: _propTypes["default"].bool,
  deploymentIdWhitelist: _propTypes["default"].array,
  showRepeatableDeploymentChildren: _propTypes["default"].bool,
  allowAllSurveys: _propTypes["default"].bool,
  customSwitchSurvey: _propTypes["default"].func,
  labelForSurvey: _propTypes["default"].string,
  showSurveyDropdown: _propTypes["default"].bool
};
var _default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(function (state) {
  return {
    assignment: (0, _admin.getCurrentAssignment)(state.assignment.admin),
    currentDeploymentId: state.assignment.admin.currentDeploymentIds.length ? state.assignment.admin.currentDeploymentIds[0] : 0,
    currentDeployment: (0, _admin.getCurrentDeployment)(state.assignment.admin),
    project: (0, _admin.getCurrentProject)(state.assignment.admin),
    organizationList: state.assignment.admin.organizationList,
    projectList: state.assignment.admin.projectList,
    selectedDeploymentIds: state.assignment.admin.selectedDeploymentIds,
    surveyHandles: state.assignment.admin.currentSurveyHandles
  };
})(Header));
exports["default"] = _default;